import {Injectable, OnDestroy} from '@angular/core';
import {LogProxy} from './log.proxy';
import * as logManager from './log.manager';
import {LogManager} from "./log.manager";
import {LoginService} from "../../../app.services/login/services/login.service";
import {DeployedEnv} from "../../env/services/env";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

/**
	****************************************************************
	* Service class for getting logger configuration from server.
	*
	* Written by: Stanislav Korobov
	****************************************************************
	*/
@UntilDestroy()
@Injectable()
export class LogService implements OnDestroy {
	constructor(private logProxy:LogProxy, private cred:LoginService, private env:DeployedEnv) {
		this.cred.observeLogins()
			.pipe(untilDestroyed(this))
			.subscribe((x) => {if (x) {
				this.getUserData();
			}});
		this.getData();
	}

	public ngOnDestroy() { }

	public getData() {
		this.logProxy.getDeafultLogConfig()
			.pipe(untilDestroyed(this))
			.subscribe((res:logManager.ILoggerConfig) => {
				LogManager.parseLoadedConfig(res, this.env.apiUrl());
			});
	}
	public getUserData(){
		this.logProxy.getAuthLogConfig()
			.pipe(untilDestroyed(this))
			.subscribe((res:logManager.ILoggerConfig) => {
				LogManager.parseLoadedConfig(res, this.env.apiUrl());
			});
	}
}

